/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WochenplanDto } from '../../models/wochenplan-dto';

export interface GetWochenplanById$Json$Params {
  id: string;
}

export function getWochenplanById$Json(http: HttpClient, rootUrl: string, params: GetWochenplanById$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<WochenplanDto>> {
  const rb = new RequestBuilder(rootUrl, getWochenplanById$Json.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WochenplanDto>;
    })
  );
}

getWochenplanById$Json.PATH = '/v1/wochenplaene/{id}';
